// extracted by mini-css-extract-plugin
export var danger = "_1o-6";
export var lightPink = "_1o-a";
export var medium = "_1o-j";
export var nearSquare = "_1o-m";
export var neutralBlue = "_1o-8";
export var neutralYellow = "_1o-7";
export var noCapitalize = "_1o-1";
export var normal = "_1o-2";
export var pill = "_1o-0";
export var primary = "_1o-3";
export var primaryLight = "_1o-4";
export var shadow = "_1o-n";
export var small = "_1o-k";
export var solidBlack = "_1o-i";
export var solidGreen = "_1o-d";
export var solidLightBlue = "_1o-f";
export var solidNavy = "_1o-e";
export var solidOrange = "_1o-h";
export var solidPink = "_1o-g";
export var solidRed = "_1o-b";
export var solidWhite = "_1o-9";
export var solidYellow = "_1o-c";
export var success = "_1o-5";
export var xsmall = "_1o-l";